const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  optionValueSelectionChange: "option-value-selection-change",
  // Fired when a variant is selected via variant-id (e.g., card picker)
  variantIdSelectionChange: "variant-id-selection-change",
  variantChange: "variant-change",
  cartError: "cart-error",
};
